import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

export default function FormatoTraslado({ usuario, onBackToMenu }) {
  const [documento, setDocumento] = useState("");
  const [nombres, setNombres] = useState("");
  const [cargoNuevo, setCargoNuevo] = useState("");
  const [sedeOrigen, setSedeOrigen] = useState("");
  const [sedeDestino, setSedeDestino] = useState("");
  const [fechaTraslado, setFechaTraslado] = useState("");
  
  const [loading, setLoading] = useState(false);
  const [buscando, setBuscando] = useState(false);

  useEffect(() => {
    // Espacio reservado por si se requiere lógica de inicio
  }, []);

  const buscarEmpleado = async (nit) => {
    if (!nit || nit.length < 5) return;
    setBuscando(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      
      const res = await fetch(`${API_URL}/api/empleados/${nit}`, {
        headers: { ...(token && { Authorization: `Bearer ${token}` }) }
      });

      const data = await res.json();
      if (res.ok && data.success && data.empleado) {
        const emp = data.empleado;
        setNombres(emp.terc_nom || "");
        setSedeOrigen(emp.area_nombre || "");
        setCargoNuevo(""); 
      } else {
        setNombres("");
        setSedeOrigen("");
        setCargoNuevo("");
      }
    } catch (err) {
      console.error("Error buscando empleado:", err);
    } finally {
      setBuscando(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!documento || !sedeDestino || !fechaTraslado) {
      return Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: 'Por favor verifique la cédula, la sede de destino y la fecha.',
        confirmButtonColor: '#3b82f6'
      });
    }

    setLoading(true);

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");

      const res = await fetch(`${API_URL}/api/th/traslado`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` })
        },
        body: JSON.stringify({
          documento_empleado: documento,
          nombres_empleado: nombres,
          cargo_nuevo: cargoNuevo,
          sede_origen: sedeOrigen,
          sede_destino: sedeDestino,
          fecha_traslado: fechaTraslado
        })
      });

      const data = await res.json();
      if (res.ok && data.success) {
        Swal.fire({
          icon: 'success',
          title: '¡Carta de Traslado Emitida!',
          text: data.message || 'El registro se ha completado con éxito.',
          confirmButtonColor: '#3b82f6'
        });
        setDocumento(""); 
        setNombres(""); 
        setCargoNuevo(""); 
        setSedeOrigen(""); 
        setSedeDestino(""); 
        setFechaTraslado("");
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al registrar',
          text: data.message || 'No se pudo emitir el traslado.',
          confirmButtonColor: '#ef4444'
        });
      }
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Error de Servidor',
        text: 'Error de red conectando con el servidor.',
        confirmButtonColor: '#ef4444'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-slate-50/80 backdrop-blur-3xl p-6 sm:p-8 rounded-[32px] shadow-sm border border-white w-full max-w-4xl mx-auto">
      <div className="flex justify-between items-center mb-8 pb-6 border-b border-gray-200">
        <div>
          <h2 className="text-2xl font-extrabold text-gray-900">📄 FO-TH-97: Formato de Traslado</h2>
          <p className="text-xs text-gray-500 mt-1">Generación de carta de traslado y control de novedades de centro de trabajo.</p>
        </div>
        <button 
          onClick={onBackToMenu} 
          className="px-6 py-2.5 bg-white text-slate-800 font-bold rounded-full shadow-sm border border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer text-xs"
        >
          Volver
        </button>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-bold uppercase mb-1 text-gray-700">Cédula del Colaborador:</label>
            <div className="relative">
              <input 
                type="text" 
                value={documento} 
                onChange={e => {
                  setDocumento(e.target.value);
                  buscarEmpleado(e.target.value);
                }} 
                placeholder="Ingrese la cédula..."
                className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-xs font-bold text-gray-800 outline-none focus:border-blue-500" 
                required 
              />
              {buscando && (
                <span className="absolute right-3 top-3 text-[10px] text-blue-600 font-bold animate-pulse">Buscando...</span>
              )}
            </div>
          </div>
          
          <div>
            <label className="block text-xs font-bold uppercase mb-1 text-gray-700">Nombres y Apellidos (Autocompletado):</label>
            <input 
              type="text" 
              value={nombres} 
              readOnly 
              placeholder="Se autocompleta al digitar la cédula..." 
              className="w-full bg-slate-100 border border-gray-200 rounded-xl px-4 py-2.5 text-xs font-extrabold text-blue-900 cursor-not-allowed" 
              required 
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <label className="block text-xs font-bold uppercase mb-1 text-gray-700">Sede de Origen:</label>
            <input 
              type="text" 
              value={sedeOrigen} 
              readOnly 
              placeholder="Automático de nómina" 
              className="w-full bg-slate-100 border border-gray-200 rounded-xl px-4 py-2.5 text-xs font-extrabold text-blue-900 cursor-not-allowed" 
              required 
            />
          </div>
          
          <div>
            <label className="block text-xs font-bold uppercase mb-1 text-gray-700">Cargo:</label>
            <input 
              type="text" 
              value={cargoNuevo} 
              onChange={e => setCargoNuevo(e.target.value)} 
              className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-xs font-bold text-gray-800 uppercase outline-none focus:border-blue-500" 
              required 
            />
          </div>

          <div>
            <label className="block text-xs font-bold uppercase mb-1 text-gray-700">Sede de Destino:</label>
            <input 
              type="text" 
              value={sedeDestino} 
              onChange={e => setSedeDestino(e.target.value)} 
              className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-xs font-bold text-gray-800 uppercase outline-none focus:border-blue-500" 
              required 
            />
          </div>
        </div>

        <div>
          <label className="block text-xs font-bold uppercase mb-1 text-gray-700">Fecha de Aplicación del Traslado:</label>
          <input 
            type="date" 
            value={fechaTraslado} 
            onChange={e => setFechaTraslado(e.target.value)} 
            className="w-full sm:w-1/2 bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-xs font-bold text-gray-800 outline-none focus:border-blue-500" 
            required 
          />
        </div>

        <div className="flex justify-end pt-4">
          <button 
            type="submit" 
            disabled={loading} 
            className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white text-xs font-extrabold rounded-full shadow-md cursor-pointer transition-colors disabled:opacity-50"
          >
            {loading ? "Generando..." : "Emitir Carta de Traslado"}
          </button>
        </div>
      </form>
    </div>
  );
}